import { useBooleanFlagValue } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";
const useSalesforce = () => {
  const isSalesforceEnabled = true; //useBooleanFlagValue(flags.SALESFORCE_ENABLED, false);
  const isSubscribeEnabled = useBooleanFlagValue(flags.SUBSCRIBE_ENABLED, true);
  return {
    isSalesforceEnabled,
    isSubscribeEnabled,
  };
};

export default useSalesforce;
